import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Checkbox extends Component {
  state = {
      isChecked: false,
      isHover: false,
  }

  toggleCheckboxChange = () => {
      const { handleCheckboxChange, value, select_option } = this.props;
      this.setState(({ isChecked }) => ({
          isChecked: !isChecked,
      }));

      handleCheckboxChange(value, select_option);
  }

  render() {

    const { label, value, select_option, checkedLabel } = this.props;
    const isChecked = select_option.has(value)
    const labelText = (isChecked && checkedLabel) ? checkedLabel : label
    
    return (
      <>
      <div className={`checkbox member-checkbox p-2 d-flex align-items-start item-${value} ${(isChecked? 'active' :'')}`}>
        <input type="checkbox" id={value} value={value} checked={isChecked} onChange={this.toggleCheckboxChange} autoComplete="off" className='d-block'/>
        <i className="icon-check m-2"></i>
        {labelText && 
          <label className={`mb-0 px-2 font-weight-semibold h6`} htmlFor={value}>{labelText}</label>
        }
      </div>
      </>
    );
  }
}

Checkbox.propTypes = {
  handleCheckboxChange: PropTypes.func.isRequired,
};

export default Checkbox;
